import React from "react";
import { Redirect, Route } from "react-router-dom";
import { ROLE } from "./shared/constants/common";

const PrivateRoute = ({ component: Component, allowRole, ...rest }) => {
    const token = localStorage.getItem("accessToken");
    const role = localStorage.getItem("role");
    const isAuthenticated = Boolean(token && token !== "");
    const userRole = parseInt(role, 10);

    const getLoginRedirectUrl = (location) => {
        const attemptedPath = `${location?.pathname || ''}${location?.search || ''}${location?.hash || ''}`;
        const redirectUrl = attemptedPath.startsWith('/') ? attemptedPath.slice(1) : attemptedPath;
        
        // Login page already reads `redirectUrl` from query params.
        // Keep it relative (no leading "/") because `getRedirectPath()` prefixes with "/".
        return redirectUrl
            ? `/login?redirectUrl=${encodeURIComponent(redirectUrl)}`
            : "/login";
    };

    const getUnauthorizedRedirect = (userRole) => {
        if (userRole === ROLE.USER) {
            return "/discover";
        }
        if (userRole === ROLE.CREATOR_SUB || userRole === ROLE.CREATOR_CONTENT) {
            return "/my-profile";
        }
        if (userRole === ROLE.ADMIN) {
            return null; // Admin can access
        }
        return "/404";
    };
    
    return (
        <Route
            {...rest}
            render={(props) => {
                if (!isAuthenticated) {
                    return <Redirect to={getLoginRedirectUrl(props.location)} />;
                }

                if (allowRole.includes(userRole)) {
                    return <Component {...props} />;
                }

                const redirectPath = getUnauthorizedRedirect(userRole);
                if (redirectPath === null) {
                    return <Component {...props} />;
                }

                return <Redirect to={redirectPath} />;
            }}
        />
    );
};

export default PrivateRoute;
